// 风险订单卡片字段
export type RiskOrder = {
    id?: number;
    // 基础信息
    order_head_id?: number; // 订单号
    server_id?: string; // 订单号
    table_name?: string; // 桌台
    people_count?: number; // 人数

    // 业务统计类字段（可由其他接口或聚合结果填充）
    dish_count?: number; // 菜品数量
    operator_name?: string; // 服务员
    open_time?: string; // 开始时间
    close_time?: string; // 结束时间
    /** 风控记录创建时间（接口 risk_order.created_at），即时列表日期筛选用 */
    created_at?: string;
    origin_amount?: number; // 原价
    actual_amount?: number; // 实收
    discount_amount?: number; // 优惠金额
    refund_dish_count?: number; // 退菜数量
    refund_amount?: number; // 退菜金额
    avg_dish_per_person?: number; // 人均菜品数量或异常菜品数
    dining_duration_min?: number; // 用餐时长

    // 风控类型：1最大优惠金额 2最大退菜数量 3最大退菜金额 4点菜数量异常 5用餐时间最大值
    risk_type?: number;
    /** 订单模式下订单包含的全部规则风险类型。 */
    risk_types?: number[];
    /** 订单模式下订单包含的全部事件风险类型。 */
    event_types?: number[];
    /** 订单模式下订单包含的全部风险记录 ID。 */
    risk_order_ids?: number[];
    // 风控事件类型 ：1快速关闭订单 2取消订单
    event_type: number;
    /** 事件风险对应的订单 ID，接口可能返回数字或字符串。 */
    event_order_id?: number | string;
    // 状态 0待确认 1已忽略 2已解决
    risk_status?: number;
    /** 云端列表等接口可能返回 status，与 risk_status 同义，详情弹窗会归一为 risk_status */
    status?: number;
    /** 订单模式下整单处理状态。 */
    orderStatus?: number;
    event_status?: number;
    // 风险类型
    source_type?: SourceType;

    // 卡片类型：异常订单 / 异常订单（取消）/ 异常订单（快速关闭）/ 异常事件...
    card_title?: string;

    // 备注/操作文案
    handle_remark?: string;
    /** 订单模式下聚合的规则风险点。 */
    riskOrders?: RiskOrder[];
    /** 订单模式下聚合的事件风险点。 */
    riskEvents?: Array<RiskOrder | RiskEvent>;
}
// 风险事件卡片字段
export type RiskEvent = {
    id?: number;
    /** 事件创建时间，ISO 时间字符串 */
    createdAt: string;

    /** 就餐类型：0 堂吃、1 堂吃打包、2 外送、3 来店自取、5 游乐园；旧接口数据可能缺失 */
    eatType?: number;

    /** 事件主键 ID */
    eventId: number;

    /** 事件编号，例如 RE1766030322582 */
    eventNo: string;

    /** 风控事件类型 ：1快速关闭订单 2取消订单 */
    eventType: number;
    /** 事件风险对应的订单 ID，接口可能返回数字或字符串。 */
    event_order_id?: number | string;

    /** 处理备注，比如“知道了知道了” */
    handleRemark?: string;

    /** 处理时间，ISO 时间字符串 */
    handledAt?: string;

    /** 处理人姓名 */
    handledBy?: string;
    // 订单
    orders?: RiskOrder[]
    // 状态 0待确认 1已忽略 2已解决
    risk_status?: number;
};

export enum SourceType {
    EVENT = 'EVENT',
    ORDER = 'ORDER'
}
